import { throttle } from 'lodash-es';

import { tabsRenderer, tabsClick, getInitialTabsData } from '../playlist-tabs/playlist-tabs';

import {
  initVideoPlaylist,
  preparePlaylistPlayer,
  hideVideoPlayer,
  removePlaylistContainer,
  buildCarouselId,
  getAllCarouselData,
  renderArrows,
  isCarouselLoading,
  tabsClickCallback,
  renderError,
} from './helpers';
import { KEY_PRESS_THROTTLE_TIME } from './constants';
import { multipleVideoPlaylistState } from './state';

/**
 * Initialize new Multiple Video Playlist
 *
 */
export const init = async () => {
  const initialTabsData = getInitialTabsData(); // Array of items (each item is a tab) coming from AEM and containing both tags & hlPrevTags.
  if (initialTabsData.length > 0) {
    preparePlaylistPlayer();
    try {
      isCarouselLoading();
      let successCarouselData = await getAllCarouselData({ initialTabsData });
      if (!successCarouselData.length) {
        // Fallback to hlPrevTags
        successCarouselData = await getAllCarouselData({ initialTabsData, hlPrevTags: true });
      }
      const firstTabData = successCarouselData[0].tabData;
      successCarouselData.forEach((element) => {
        const carouselId = buildCarouselId(element.tabData.tabIndex);
        multipleVideoPlaylistState.getState('tabsMap').set(carouselId, element.carouselData);
      });
      isCarouselLoading(false);

      /* initialize first TAB */
      multipleVideoPlaylistState.setState('currentCarouselId', buildCarouselId(firstTabData.tabIndex));
      const initialCarouselData = multipleVideoPlaylistState
        .getState('tabsMap')
        .get(multipleVideoPlaylistState.getState('currentCarouselId'));
      multipleVideoPlaylistState.setState('selectedTabId', multipleVideoPlaylistState.getState('currentCarouselId'));
      if (initialCarouselData.length > 0) {
        renderArrows(initialCarouselData.length);
        multipleVideoPlaylistState.setState(
          'playlist',
          initVideoPlaylist(initialCarouselData, multipleVideoPlaylistState.getState('currentCarouselId'))
        );
      } else {
        /* Error in getCarousel Data */
        console.warn('[ INIT - CAROUSEL ] multiple-video-playlist error in getCarouselData() ');
        renderError(multipleVideoPlaylistState.getState('playlist'), multipleVideoPlaylistState.getState('carouselId'));
        hideVideoPlayer();
        removePlaylistContainer();
        throw new Error('[ INIT - CAROUSEL ] Error in Carousel Data');
      }
      const tabsData = successCarouselData.map((element) => element.tabData);
      tabsRenderer(tabsData);
      tabsClick(throttle(tabsClickCallback, KEY_PRESS_THROTTLE_TIME, { trailing: false }));
    } catch (error) {
      /* Error in getCarousel Data */
      console.warn(`[ INIT - CAROUSEL ] multiple-video-playlist error in getCarouselData() - Error: ${error}`);
      hideVideoPlayer();
      removePlaylistContainer();
      isCarouselLoading(false);
      throw error;
    }
  } else {
    /* Error in Tabs */
    console.warn('[ INIT - CAROUSEL ] multiple-video-playlist error in error in tabs ');
    hideVideoPlayer();
    removePlaylistContainer();
    throw new Error('[ INIT - CAROUSEL ] Error in Tabs');
  }
};
